import { PickInfo } from "deck.gl";
import { FilterState } from "./fish-map/FilterMenu";
import "./picked-object-view.css";


const score_to_text = ["<10%", "10-20%", "20-30%", "30-40%", "40-50%", "50-60%", "60-70%", "70-80%", "80-90%", ">90%"]

export const getTooltip = (translateFunc: (key: string, args?: any) => string, info: PickInfo<any>, filterState: FilterState) => {
    const t = translateFunc;

    if (!info.object) return;
    const object = info.object;

    const [lat, lon] = object.geometry.coordinates;
    let score = null;
    const {species, daysAhead} = filterState;
    // Fiskebåter
    if (object.properties.mmsi) {
        return t("MapEntity.Vessel", {...object.properties, lat, lon});
    } 
    // Fiskemottak
    if (object.properties.name) {
        return t("MapEntity.FishFacility", {...object.properties, lat, lon});
    } 

    // Rute lokasjoner
    if (object.properties.type === "route-point") {
        if (object.properties.start) {
            return t("MapEntity.RouteStart", { lat, lon });
        }
        score = Math.ceil((parseFloat(object.properties.prob) * 9))
        let fuel = object.properties.remaining_fuel_ltrs;
        return t("MapEntity.RouteSpot", {...object.properties, id: object.id, fuel, lat, lon, score: score_to_text[score] });
    }
     // Rute linje
    if (object.properties.total_dist_km) {
        return t("MapEntity.RouteLine", { ...object.properties, tons: object.properties.total_load_kgs/1000 });
    }

    // Heatmap lokasjoner
    if (object.properties[species]) {
        score = Math.ceil((parseFloat(object.properties[species]) * 9));
        return t("MapEntity.HeatmapSpot", {...object.properties, score: score_to_text[score], species: t(`Species.${species}`) });
    }
    // Beste posisjon
    if (object.properties.probability) {
        score = Math.ceil((parseFloat(object.properties.probability) * 9))
        var chosenDate = new Date();
        chosenDate.setDate(chosenDate.getDate() + daysAhead);
        var dd = String(chosenDate.getDate()).padStart(2, '0');
        var mm = String(chosenDate.getMonth() + 1).padStart(2, '0'); //January is 0!
        let chosenDateAsString = dd + '-' + mm;
        return t("MapEntity.BestSpot", {...object.properties, species: t(`Species.${species}`), chosenDateAsString, score: score_to_text[score] });
    } 
    if (object.properties.description) {
        return object.properties.description;
    }
   
    // Nye punkter som vi ikke har lagt til støtte for 
    return t("MapEntity.Unknown");
};
export type TooltipFunc = (pickInfo: PickInfo<any>) => string | undefined;
type PickedObjectViewProps = {
    pickInfo: PickInfo<any>
    getTooltip: TooltipFunc
}

export function PickedObjectView(props: PickedObjectViewProps) {
    return <div className="pickedObjectView">
        <span style={{ whiteSpace: 'pre-wrap' }}>{props.getTooltip(props.pickInfo)}</span>
    </div>;
}
